import { FC } from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import RowActions, {
  RowAction,
  rowActionsWidth,
} from '../../components/RowActions';
import { colors, fontWeights } from '../../theme/tokens';
import { UserRow } from './types';

// The two per-row actions of XD screen 8: pencil and trash can, over
// the common "•••" (components/RowActions).

export type UserAction = 'edit' | 'delete';

export const USER_ACTIONS_WIDTH = rowActionsWidth(2);

const EDIT: RowAction<UserAction> = {
  key: 'edit',
  label: 'Modifier',
  icon: <EditOutlinedIcon fontSize="small" />,
};

const DELETE: RowAction<UserAction> = {
  key: 'delete',
  label: 'Supprimer',
  icon: <DeleteOutlinedIcon fontSize="small" />,
};

export const displayName = (user: UserRow): string =>
  [user.firstname, user.lastname].filter(Boolean).join(' ').trim() ||
  user.email;

type Props = {
  user: UserRow;
  /** No trash can on one's own account (see pages/UsersList). */
  canDelete: boolean;
  variant: 'table' | 'card';
  onAction: (action: UserAction, user: UserRow) => void;
};

const UserRowActions: FC<Props> = ({ user, canDelete, variant, onAction }) => (
  <RowActions
    subject={displayName(user)}
    actions={canDelete ? [EDIT, DELETE] : [EDIT]}
    variant={variant}
    width={USER_ACTIONS_WIDTH}
    onAction={(action) => onAction(action, user)}
  />
);

// "Prénom NOM" from the XD: the last name in uppercase via CSS, so that the DOM
// (and what is copied) keeps the last name as it was written. It links to the
// user record, as the previous listing did.
export const UserName: FC<{ user: UserRow }> = ({ user }) => (
  <Link
    to={`/view-user/${user.id}`}
    style={{
      color: colors.textBase,
      fontWeight: fontWeights.medium,
      textDecoration: 'none',
      overflowWrap: 'anywhere',
    }}
  >
    {user.firstname || user.lastname ? (
      <>
        {user.firstname}
        {user.firstname && user.lastname ? ' ' : ''}
        <Box component="span" sx={{ textTransform: 'uppercase' }}>
          {user.lastname}
        </Box>
      </>
    ) : (
      user.email
    )}
  </Link>
);

export default UserRowActions;
